import React, { useEffect, useState } from 'react';
// import { Swiper, SwiperSlide } from "swiper/react";
// import required modules
import "swiper/css";
import 'swiper/css/pagination';
import config from '../../../config';
import axios from 'axios';
import { Link } from 'react-router-dom';


const App: React.FC = () => {

  // const [productArray, setProductArray] = useState<OfferedProductArray[]>([]);
  const formatter = new Intl.NumberFormat('bn-BD');

  const fetchProductData = async () => {
    // try {
    //   const response = await axios.get<{ data: { data: OfferedProductArray[] } }>(config.apiUrl+'product');
        
    //   if (response.status === 200) {
    //     setProductArray(response.data.data.data); 
    //     console.log('_product_list', response.data.data.data); 
    //   } else {
    //     console.error('Failed to fetch product data');
    //   }
    // } catch (error) {
    //   console.error('Error fetching product data:', error);
    // }
  };

  useEffect(() => {
    fetchProductData();
  }, [0]);


  return (
    <div className="App">
      {/* ------------সেবা সমূহ start---------- */}
      <section className="offer-products py-2">
        <div className="container">
          <h3 className="heading-text text-center mb-4"> সেবা সমূহ</h3>
          <div className="row mb-5">
          <div className='col-md-10 mx-auto'>
            <div className="row mt-1 h-100">
                <div className='col-md-3 my-3 col-6'>
                  <div className="product-card2 h-100 pb-1">
                    <div className="product-image">
                      <img src='./assets/img/products/pre-registration-icon.png' alt="not found" className='img-fluid' />
                    </div>
                    <div className="product-info">
                      <h5 className="product-title">হজ্জ</h5>
                    </div>
                    </div>
                </div>
                <div className='col-md-3 my-3 col-6'>
                  <div className="product-card2 h-100 pb-1">
                    <div className="product-image">
                      <img src='./assets/img/products/pre-registration-icon.png' alt="not found" className='img-fluid' />
                    </div>
                    <div className="product-info">
                      <h5 className="product-title">ওমরা</h5>
                    </div>
                    </div>
                </div>
                <div className='col-md-3 my-3 col-6'>
                  <div className="product-card2 h-100 pb-1">
                    <div className="product-image">
                      <img src='./assets/img/products/pre-registration-icon.png' alt="not found" className='img-fluid' />
                    </div>
                    <div className="product-info">
                      <h5 className="product-title">এয়ার টিকেট</h5>
                    </div>
                    </div>
                </div>
                <div className='col-md-3 my-3 col-6'>
                  <div className="product-card2 h-100 pb-1">
                    <div className="product-image">
                      <img src='./assets/img/products/pre-registration-icon.png' alt="not found" className='img-fluid' />
                    </div>
                    <div className="product-info">
                      <h5 className="product-title">হোটেল বুকিং</h5>
                    </div>
                    </div>
                </div>
            </div>
          </div>
          </div>
        </div>
      </section>
      {/* ------------সেবা সমূহ start---------- */}
      {/* --------------করনীয় সমুহ--------- */}
      <section className="best-selling-part card-design py-5">
        <div className="container">
          <h3 className="heading-text mb-3 text-center">করনীয় সমুহ</h3>
          <div className="row">
            <div className='col-md-9 mx-auto'>
              <div className='suggestion-area'>
                <ul>
                  <li><i className="fa-solid fa-right-long"></i> ঢাকা এয়ারপোর্ট থেকে যাত্রা শুরু করে পূনরায় ঢাকা আসা পর্যন্ত আমাদের নিজস্ব প্রতিনিধির তত্বাবধান</li>
                  <li><i className="fa-solid fa-right-long"></i> নিজস্ব তত্বাবধানে পবিত্র হজ্জ ও ওমরা সঠিক ভাবে পালনের সার্বিক সহযোগীতা</li>
                  <li><i className="fa-solid fa-right-long"></i> পবিত্র ক্বাবা শরীফ ও মদিনা শরীফে এবাদতের জন্য সহযোগীতা করা</li>
                  <li><i className="fa-solid fa-right-long"></i> বিশেষ সুবিধাপ্রাপ্ত হাজী সাহেবান্দের জন্য ৫ স্টার হোটেলে (হিল্টন ও জম জম টাওয়ার) থাকার ব্যবস্থা মক্কা ও মদিনায় শীতাতপ নিয়ন্ত্রিত উন্নত হোটেল</li>
                  <li><i className="fa-solid fa-right-long"></i> মক্কা ও মদিনায় ঐতিহাসিক ও দর্শনীয় স্থান সমূহ এজেন্সীর খরচে যিয়ারত করানো</li>
                  <li><i className="fa-solid fa-right-long"></i> সম্মানিত হাজী সাহেবদেরকে হজ্জ ও অমরার উপর বিশেষ প্রশিক্ষনের ব্যবস্থা</li>
                  <li><i className="fa-solid fa-right-long"></i> যাতায়াতঃ সরাসরি ঢাকা-জেদ্দা, ঢাকা-মদিনা অথবা ট্রানজিট</li>
                  <li><i className="fa-solid fa-right-long"></i> মহিলাদের জন্য আলাদা রুমের ব্যবস্থা</li>
                  <li><i className="fa-solid fa-right-long"></i> দেশীয় খাবারের সু-ব্যবস্থা</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* --------------করনীয় সমুহt start--------- */}
      {/* --------------হজ্জ্বের ফরয ও ওয়াজিব সমুহstart--------- */}
      <section className="best-selling-part card-design py-5">
        <div className="container">
          <h3 className="heading-text mb-5 text-center">হজ্জ্বের ফরয ও ওয়াজিব সমুহ</h3>
            <div className='row'>
              <div className='col-md-10 mx-auto'>
                <div className='row'>
                  <div className='col-md-6'>
                      <div className="product-card3">
                        <div className="product-info">
                          <h5 className="product-title">হজ্জ্ব</h5>
                        </div>
                        <div className="product-description">
                          <p><strong>হজ্জ্বের ফরয সমূহ (৩টি)</strong></p>
                          <p>১. ইহরাম বাধা – হজ্জের নিয়ত করা এবং তালবিয়া পাঠ করা।</p>
                          <p>২. আরাফাতে অবস্থান করা – ৯ই জিলহজ্জ্ব সূর্যাস্ত পর্যন্ত কিছুক্ষণ হলেও আরাফাত ময়দানে থাকা।</p>
                          <p>৩. তাওয়াফে জিয়ারত (তাওয়াফুল ইফাদা) – ১০ই জিলহজ্জ্ব থেকে শুরু করে ১২ই জিলহজ্জ্বের মধ্যে কাবা শরীফের চারপাশে সাত চক্কর তাওয়াফ করা।</p>
                          <p><strong>হজ্জ্বের ওয়াজিব সমূহ</strong></p>
                          <p>১. সাফা-মারওয়া পাহাড়ের মধ্যে সাতবার সায়ী করা।</p>
                          <p>২. মুযদালিফায় রাত যাপন করা এবং ফজরের নামাজ আদায় করা।</p>
                          <p>৩. মিনায় রমী (শয়তানকে পাথর নিক্ষেপ) করা।</p>
                          <p>৪. কুরবানী করা (যারা তামাত্তু ও কিরান হজ্জ্ব করবেন তাদের জন্য)।</p>
                          <p>৫. মাথা মুণ্ডানো বা চুল ছোট করা।</p>
                          <p>৬. বিদায়ী তাওয়াফ (তাওয়াফে বিদা) করা (শুধুমাত্র অ-স্থানীয়দের জন্য)।</p>
                          <p>৭. নির্ধারিত সময়ে হজ্জ্বের কার্যক্রম সম্পন্ন করা।</p>
                          <p>ফরয কোনো একটি বাদ পড়লে হজ্জ্ব শুদ্ধ হবে না, আর ওয়াজিব কোনোটি বাদ পড়লে দম (কুরবানী) দিতে হবে।</p>
                        </div>
                      </div>
                  </div>
                  <div className='col-md-6'>
                      <div className="product-card3">
                        <div className="product-info">
                          <h5 className="product-title"> ওমরা হজ্জ্ব </h5>
                        </div>
                        <div className="product-description">
                        <p><strong>ওমরার ফরয (অবশ্যক বিষয়)</strong></p>
                          <p>১. ওমরায় দুটি ফরয রয়েছে, যা পালন না করলে ওমরা সম্পন্ন হবে না:</p>
                          <p>২. ইহরাম বাঁধা – মীকাত থেকে নির্দিষ্ট নিয়তে ইহরাম গ্রহণ করা।</p>
                          <p>তাওয়াফ করা – কাবা শরীফের চারপাশে সাত চক্কর ঘোরা।</p>
                          <p><strong>ওমরার ওয়াজিব (অপরিহার্য বিষয়)</strong></p>
                          <p>১. ওমরায় কয়েকটি ওয়াজিব রয়েছে, যা ইচ্ছাকৃতভাবে পরিত্যাগ করলে দম (একটি পশু কুরবানি) দিতে হয়:</p>
                          <p>২.সাফা-মারওয়া সাঈ করা – সাফা ও মারওয়া পাহাড়ের মাঝে সাতবার হাঁটা</p>
                          <p>৩. মারওয়ায় সাঈ শেষ করা – শেষ চক্কর মারওয়ায় শেষ করতে হবে।</p>
                          <p>৪. মুন্ডন বা চুল ছোট করা – পুরুষদের মাথার চুল মুন্ডানো বা ছোট করা এবং নারীদের সামান্য চুল কাটা।</p>
                          <p>৫. তাওয়াফ ও সাঈ ধারাবাহিকভাবে করা – বিরতি ছাড়া পরপর করা উত্তম।</p>
                          <p>৬. তাওয়াফের সময় বাহিরের কাপড় কাঁধে ফেলা (পুরুষদের জন্য) – প্রথম তিন চক্করে রমল (তীব্রভাবে চলা) করা।</p> <br /> <br /><br />
                        </div>
                      </div>
                  </div>
                </div>
                <div className=" mt-5 text-center">
                  {/* <Link to="/default" className="theme-btn btn-sm">আরও দেখুন</Link> */}
                </div>
              </div>
            </div>
            <div className='my-5'>
              <div className='row'>
                <div className='col-md-10 mx-auto'>
                  <div className='promotion-area'>
                    <div className='px-5 d-flex justify-content-between align-items-center flex-wrap flex-md-nowrap'>
                      <div><p className='m-0 text-white text-center pe-4'>লাব্বাইক আল্লাহুম্মা লাব্বাইক, লাব্বাইকা লা-শারিকা লাকা লাব্বাইক, ইন্নাল হামদা ওয়ান নি'মাতা লাকা ওয়াল মুলক, লা- শারিকা লাক</p></div>
                      {/* <div className='d-none d-md-block'><button className='btn btn-white'>শুনুন</button></div> */}
                      {/* <div className='text-center d-md-none d-block w-100 mt-3'><button className='btn btn-white'>শুনুন</button></div> */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
        </div>
      </section>
      {/* --------------হজ্জ্বের ফরয ও ওয়াজিব সমুহ start--------- */}
    </div>
  );
}

export default App;